module.exports = __webpack_public_path__ + "static/media/xmg_tropical_fruit.a234e968.png";